import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { SITE } from "@/constants/site";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PayDepositButton({ bookingType = "private_event_deposit" }) {
  const [busy, setBusy] = useState(false);
  const [mode, setMode] = useState("live");

  useEffect(() => {
    axios
      .get(`${API}/payments/config`)
      .then(({ data }) => setMode(data.mode))
      .catch(() => setMode("live"));
  }, []);

  const pay = async () => {
    if (busy) return;
    setBusy(true);
    try {
      const { data } = await axios.post(`${API}/payments/checkout`, {
        booking_type: bookingType,
        origin_url: window.location.origin,
      });
      window.location.href = data.checkout_url;
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not start checkout. Try again.");
      setBusy(false);
    }
  };

  return (
    <div className="flex flex-col items-start gap-2">
      <button
        onClick={pay}
        disabled={busy}
        data-testid="pay-deposit-button"
        className="inline-flex cursor-pointer items-center justify-center gap-2 rounded-full bg-terracotta px-7 py-3.5 text-sm font-medium tracking-wide text-cream transition-[background-color,color,transform] duration-300 hover:-translate-y-0.5 hover:bg-gold hover:text-deepforest disabled:opacity-60"
      >
        {busy ? "Opening Stripe…" : `Pay deposit · ${SITE.depositAmount}`}
      </button>
      {mode === "test" && (
        <span data-testid="stripe-test-mode-badge" className="text-[11px] uppercase tracking-[0.18em] text-terracotta/80">
          Stripe test mode — ready to connect
        </span>
      )}
    </div>
  );
}
